import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";

interface IProps {
  mobileOpen: boolean;
  setStateMobileOpen: Dispatch<SetStateAction<boolean>>;
}

const Hamburger: React.FunctionComponent<IProps> = ({
  mobileOpen,
  setStateMobileOpen
}) => {
  return (
    <HamburgerIcon
      className={mobileOpen ? "active" : ""}
      onClick={() => {
        setStateMobileOpen(!mobileOpen);
      }}
    >
      <span className="line line-1" />
      <span className="line line-2" />
      <span className="line line-3" />
    </HamburgerIcon>
  );
};

const widthLine = 30;
const heightIcon: number = 24;
const heightLine = 2;
const transitionTime = 0.2;
const translateY = heightIcon / 2;
const translateX = 0;
const rotation = "45deg";

const HamburgerIcon = styled.div`
  cursor: pointer;
  width: ${widthLine}px;
  height: ${heightIcon}px;
  position: relative;
  display: block;
  margin: (${heightIcon}px * 2) auto ${heightIcon}px auto;
  transition: all ${transitionTime}s;
  margin-right: 44px;
  .line {
    display: block;
    background: #6d9cf9;
    width: ${widthLine}px;
    height: ${heightLine}px;
    position: absolute;
    left: 0;
    border-radius: (${heightLine / 2}px);
    transition: all ${transitionTime}s;
    &.line-1 {
      top: 0;
    }
    &.line-2 {
      top: 50%;
    }
    &.line-3 {
      top: 100%;
    }
  }
  :hover,
  :focus {
    .line-1 {
      transform: translateY(-${heightLine / 2}px);
    }
    .line-3 {
      transform: translateY(${heightLine / 2}px);
    }
  }
  &.active {
    .line-1 {
      transform: translateY(${translateY}px) translateX(${translateX}px)
        rotate(${rotation});
    }
    .line-2 {
      opacity: 0;
    }
    .line-3 {
      transform: translateY(-${translateY}px) translateX(${translateX}px)
        rotate(-${rotation});
    }
  }
`;

export default Hamburger;
